<template>
	<section class="ProjectAppointmentsPage">
		<header class="Header">
			<a class="Header-logo" href="/">
				<img src="/map/dist/skin/logo.svg" alt="Logo"/>
			</a>
			<span v-if="isLoading"
				  style="color: #777; font-size: 13px; position: absolute; display: flex; justify-content: center; align-items: center; left: 50%; top: 5px; margin-left: -15px; background: #fff; box-shadow: 0 2px 5px rgba(0,0,0,0.5); border-radius: 9999px; width: 30px; height: 30px;">
        		<LoadingIndicator style="height: 16px;"/>
			</span>
		</header>
		<div class="Subheader">
			<Button class="header-buttons" @click="previousDay" :disabled="activeDate === minDate">
				<ArrowLeftIcon
					size="24"/>
			</Button>
			<Button class="header-buttons" :primary="true" @click="toDay" style="width: 100%; max-width: 300px; text-align:
			center;">
				{{ formattedDate(activeDate) }}
			</Button>
			<Button class="header-buttons" @click="nextDay" :disabled="activeDate === maxDate">
				<ArrowRightIcon size="24"/>
			</Button>
		</div>
		<div class="Subheader" v-if="allowedTo(['doorgeven/uren'])">
			<Button class="hours-button" @click="startWorkDay" :disabled="workdayStartTime != null">
				{{ workdayStartTime == null ? 'BEGIN' : 'BEGONNEN OM ' + workdayStartTime }}
			</Button>
			<Button class="hours-button" @click="endWorkDay" :disabled="workdayEndTime != null">
				{{ workdayEndTime == null ? 'EINDE' : 'GEEINDIGD OM ' + workdayEndTime }}
			</Button>
		</div>
		<main class="ProjectAppointmentsPage-main" ref="main">
			<div class="Appointments">
				<div v-if="!isLoading && appointmentList.length === 0" class="Appointments__Empty Card">
					<CalendarIcon size="10x" color="#ddd"/>
					<div style="margin: 1em 0;">Geen afspraken gevonden</div>
				</div>
				<div v-for="appointment in appointmentList" :key="appointment.id" class="project"
					 @click="$router.push({ name: 'projectAppointmentsdetail', params: {id: appointment.id} })">
					<div class="phone-section">
						<a class="icon" :class="{disabled: appointment.phone == null}"
						   :href="appointment.phone == null ? '' : `tel:${appointment.phone}`"
						   @click.stop="">
							<Phone-icon/>
						</a>
						<span>
							{{ appointment.company.salutation }}
							{{ appointment.company.companyname }}
						</span>
					</div>
					<div class="location-section">
						<a class="icon" :class="{disabled: appointment.locationUrl == null}"
						   :href="appointment.locationUrl == null ? '' : appointment.locationUrl"
						   target="_blank" @click.stop="">
							<Navigation-icon/>
						</a>
						<span>
							{{ appointment.company.visitingaddress_street }} {{ appointment.company.visitingaddress_streetnumber}}<br/>
							{{ appointment.company.visitingaddress_zipcode }}<br/>
							{{ appointment.company.visitingaddress_city }}
						</span>
					</div>
					<div class="time-section">
						<span>
							{{
								appointment.planned_start_time != null ?
									appointment.planned_start_time.substring(0, 5) :
									'-'
							}}
						</span>
					</div>
				</div>
			</div>
		</main>
		<div class="Footer">
			<Button
				class="Footer-availability-button"
				v-if="allowedTo(['doorgeven/ziekte', 'doorgeven/verlof'])"
				@click="$router.push({name: 'doorgeven'})">
				<MenuIcon size="24"/>
			</Button>
		</div>
	</section>
</template>

<script>
import {client} from "@/store";
import _ from "lodash";
import {mapState, mapActions, mapMutations, mapGetters} from 'vuex';
import Button from '@/components/Button';
import LoadingIndicator from '@/components/LoadingIndicator';
import {
	PhoneIcon, NavigationIcon, RefreshCwIcon, LogOutIcon,
	ArrowLeftIcon, ArrowRightIcon, CalendarIcon, SearchIcon, MenuIcon
} from "vue-feather-icons";
import moment from 'moment';
import 'moment/locale/nl';

export default {
	components: {
		Button,
		LoadingIndicator,
		PhoneIcon,
		NavigationIcon,
		RefreshCwIcon,
		LogOutIcon,
		ArrowLeftIcon,
		ArrowRightIcon,
		CalendarIcon,
		SearchIcon,
		MenuIcon,
	},

	data() {
		return {
			active: null,
			activeDate: moment().format('YYYY-MM-DD'),
			maxDate: moment().add(7, 'days').format('YYYY-MM-DD'),
			minDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
			workdayStartTime: null,
			workdayEndTime: null
		};
	},

	mounted() {
		this.refresh();
		this.getWorkingHoursForToday();

		this.periodical = setInterval(() => {
			this.refresh();
		}, 60000);
	},

	destroyed() {
		clearTimeout(this.periodical);
	},

	computed: {
		...mapState({
			isLoading: 'loading',
		}),
		...mapState('auth', {
			viewer: 'viewer',
		}),
		...mapState('appointments', {
			appointments: 'appointments',
		}),
		...mapGetters({
			allowedTo: "auth/allowedTo"
		}),

		appointmentList() {
			let lastDate = null;
			return this.appointments.map(appointment => {
				if (lastDate !== appointment.date) {
					lastDate = appointment.date;
					appointment.showDate = true;
				}

				appointment.nextDay = (appointment.datediff !== '0');

				return appointment;
			});
		},

		formattedDate: () => date => {
			return moment(date, 'YYYY-MM-DD').format('dd, D MMM YYYY');
		},
	},

	methods: {
		...mapActions({
			logoutUser: 'auth/logoutUser',
			getAppointments: 'appointments/fetchAppointments',
		}),

		doLogout() {
			this.logoutUser();
			this.$router.push({name: 'login'}).catch((error) => {
				if (error) console.error(error)
			});
		},

		refresh() {
			this.getAppointments({
				date: this.activeDate, employeeId: this.viewer.id, orderBy:
					'planned_start_time', orderDirection: 'ASC'
			});
		},

		toDay() {
			this.activeDate = moment().format('YYYY-MM-DD');
			this.keywords = '';
			this.refresh();
			this.$refs.main.scrollTo({
				top: 0,
				left: 0,
			});
		},

		previousDay() {
			if (this.activeDate === this.minDate) {
				return;
			}
			this.activeDate = moment(this.activeDate, 'YYYY-MM-DD').subtract(1, 'days').format('YYYY-MM-DD');
			this.keywords = '';
			this.refresh();
			this.$refs.main.scrollTo({
				top: 0,
				left: 0,
			});
		},

		nextDay() {
			if (this.activeDate === this.maxDate) {
				return;
			}
			this.activeDate = moment(this.activeDate, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
			this.keywords = '';
			this.refresh();
			this.$refs.main.scrollTo({
				top: 0,
				left: 0,
			});
		},
		getWorkingHoursForToday() {
			client.query(`query {
									todaysWorkingHoursCurrentUser {
										id
										start_time
										end_time
									}
					}`, {}).then(result => {
				if (result.todaysWorkingHoursCurrentUser == null) {
					console.error('Error getting working hours for today failed');
					this.showErrorForGetWorkingHoursForToday();
					return;
				}
				if(result.todaysWorkingHoursCurrentUser.start_time != null) {
					this.workdayStartTime = result.todaysWorkingHoursCurrentUser.start_time.slice(0, -3);
				}
				if(result.todaysWorkingHoursCurrentUser.end_time != null) {
					this.workdayEndTime = result.todaysWorkingHoursCurrentUser.end_time.slice(0, -3);
				}
			}).catch(error => {
				console.error('Error getting working hours for today failed');
			});
		},
		startWorkDay() {
			client.query(`mutation {
        							startWorkDay
					}`, {}).then(result => {
				if (result.startWorkDay !== true) {
					console.error('Error starting work day failed');
					this.showErrorForStartWorkDay();
					return;
				}
				this.$notify({
					group: 'app',
					title: 'Begin werkdag',
					type: 'success',
					text: `De werkdag is begonnen.`,
				});
				this.getWorkingHoursForToday();
			}).catch(error => {
				console.error('Error starting work day failed');
				this.showErrorForStartWorkDay();
			});
		},
		showErrorForStartWorkDay() {
			this.$notify({
				group: 'app',
				title: 'Begin werkdag',
				type: 'error',
				text: `Er is een fout opgetreden bij het beginnen van de werkdag.`,
			});
		},
		endWorkDay() {
			client.query(`mutation {
        							endWorkDay
					}`, {}).then(result => {
				if (result.endWorkDay !== true) {
					console.error('Error ending work day failed');
					this.showErrorForEndWorkDay();
					return;
				}
				this.$notify({
					group: 'app',
					title: 'Einde werkdag',
					type: 'success',
					text: `De werkdag is beëindigd.`,
				});
				this.getWorkingHoursForToday();
			}).catch(error => {
				console.error('Error ending work day failed');
				this.showErrorForEndWorkDay();
			});
		},
		showErrorForEndWorkDay() {
			this.$notify({
				group: 'app',
				title: 'Einde werkdag',
				type: 'error',
				text: `Er is een fout opgetreden bij het eindigen van de werkdag.`,
			});
		},
	},
};
</script>

<style scoped lang="scss">

.Header {
	justify-content: center;
}

.Subheader {
	position: relative;
	top: 0;
	display: flex;
	justify-content: space-between;
	align-items: center;
	z-index: 11;
	background: #EEE;
	color: #000;
}

.ProjectAppointmentsPage-main {
	z-index: 0;
	position: relative;
	height: calc(100vh - 88px);
	overflow: auto;
	background: rgb(238, 238, 238);
	padding-bottom: 3em;
}

.Footer {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 10;
	display: flex;
	flex-direction: column;
}

.Footer-availability-button {
	font-weight: 800;
	background: #006767;
	color: #ffffff;
	border-radius: 50%;
	width: 54px;
	height: 54px;
	text-align: center;
	margin-left: auto;
	margin-right: 16px;
	margin-bottom: 16px;
}

.Appointments {
	margin: 0 8px;
	width: calc(100% - 16px);
}

.Appointments__Empty {
	margin: 1em 0;
	padding: 2em;
	text-align: center;
	color: #aaa;
}

h2, h3 {
	margin: 0 0 0.5em 0;
}

.project {
	display: grid;
	background-color: #fff;
	border-bottom: 2px solid #eee;
	grid-template-areas:
        "phone time"
        "location time";
	padding: 4px 0;
	color: #000;
	cursor: pointer;
}

.project:nth-last-child(1) {
	margin-bottom: 150px;
}

.phone-section {
	grid-area: phone;
	display: flex;
	margin: 4px 8px;
	align-items: center;
}

.location-section {
	grid-area: location;
	display: flex;
	margin: 4px 8px;
	align-items: center;
}

.time-section {
	grid-area: time;
	display: flex;
	align-self: center;
	justify-content: flex-end;
	margin-right: 16px;
	align-items: center;
}

.time-section span {
	font-size: 2rem;
	font-weight: 900;
}

.icon {
	min-width: 60px;
	width: 60px;
	min-height: 60px;
	height: 60px;
	display: flex;
	justify-content: center;
	align-items: center;
	text-decoration: none;
	color: #fff;
	border-radius: 8px;
	margin-right: 16px;
}

.icon.disabled {
	opacity: 0.5;
	cursor: not-allowed;
	text-decoration: none;
	pointer-events: none;
}

.phone-section .icon {
	background: #1f88e5;
}

.location-section .icon {
	background: #35a5a4;
}

.icon path {
	fill: #FFF;
}

.icon polygon {
	fill: #FFF;
}

.header-buttons {
	background: #eee;
	border: none;
	box-shadow: none;
	color: #000;
	font-size: 1rem;
	font-weight: 800;
	text-align: center;
}

.Header-logo {
	display: flex;
	height: 100%;
	width: 100%;
	align-items: center;
	justify-content: center;
}

.hours-button {
	margin: 0 8px;
	text-align: center;
	border-radius: 4px;
	width: 50%;
	background-color: #1aae9f;
	color: #fff;
	font-weight: bold;
	font-size: 1rem;
}
</style>
